import React from 'react';
import Toggleable from 'views/plugins/ui/toggleable';
import Picture from 'views/plugins/checkout/summary/picture';
import Header from 'views/plugins/checkout/summary/header';
import Pricing from 'views/plugins/checkout/summary/pricing';
import CancellationPolicy from 'views/plugins/checkout/summary/cancellation_policy';
import RequestInfo from 'views/plugins/checkout/summary/request_info';
import { t } from 'services/translation';
import './index.scss';
import { DepositInfoText } from 'views/plugins/confirmation/styles';

class ConfirmationSummary extends React.Component {
  _pricingContent = () => {
    return (
      <div className="ConfirmationSummary-ToggleContent">
        <Pricing
          {...this.props.pricing}
          guide_full_name={this.props.header.guide_full_name}
        />
      </div>
    );
  };

  _renderCancellationPolicy = () => {
    if (this.props.pricing.paid_in_cash || this.props.for_custom_booking) {
      return null;
    }
    return <CancellationPolicy {...this.props.cancellationPolicy} />;
  };

  _renderPriceBreakdown = () => {
    if (this.props.pricing.subtotal === 0) {
      return null;
    }

    return this._pricingContent();
  };

  render() {
    const { is_live_booking } = this.props;
    const { tour_name, business_name } = this.props.header;
    if (is_live_booking)
      return (
        <div className="live-checkout-container">
          <p className="tour-name">{tour_name}</p>
          <p className="business-name">
            {t('WITH')} {business_name}
          </p>
        </div>
      );
    return (
      <div className="ConfirmationSummary-SummaryDetails">
        <Picture {...this.props.picture} />
        <Header {...this.props.header} />
        {!is_live_booking && (
          <div>
            <RequestInfo {...this.props.requestInfo} />
            {this._renderCancellationPolicy()}
            {this._renderPriceBreakdown()}
          </div>
        )}
      </div>
    );
  }
}

export default ConfirmationSummary;
